'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import Raven from 'raven-js';
import { Component } from 'react';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { growl } from './growl';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ErrorBoundary extends Component {
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      switch (this.props.type) {
        case 'info':
          return /*#__PURE__*/_jsx(UIAlert, {
            type: "danger",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "EmailComponents.errors.boundaryDefault"
            })
          });
        case 'alert':
          growl('error', I18n.text('EmailComponents.errors.boundaryDefault'));
          return null;
        default:
          return /*#__PURE__*/_jsx(UIErrorMessage, {
            title: /*#__PURE__*/_jsx("span", {}),
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "EmailComponents.errors.boundaryDefault"
            })
          });
      }
    }
    return this.props.children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['default', 'info', 'alert'])
};
ErrorBoundary.defaultProps = {
  children: null,
  type: 'default'
};